module.exports = __webpack_public_path__ + "img/no_data_2.bd98cff0.png";